// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import useCoinRules from '../queries/cn/useCoinRules';

export const useIsDevNet = () => {
  const coinRules = useCoinRules();
  const isDevNet = !coinRules.isLoading && !!coinRules.data && coinRules.data.payload.isDevNet;
  return isDevNet;
};
